import type { FeedbackMessages } from './en';

const id: FeedbackMessages = {
  qualified: {
    title: 'Terima kasih telah menyelesaikan studi ini!',
    text: 'Anda dapat menutup jendela browser ini.\n\nKami berharap dapat bertemu dengan Anda lagi segera.',
  },
  quotaFull: {
    title: 'Studi ini telah ditutup',
    text: 'Terima kasih atas minat Anda terhadap studi kami.\n\nSayangnya kami telah menerima semua tanggapan yang kami perlukan.\n\nKami berharap dapat bertemu dengan Anda di salah satu studi kami mendatang!',
  },
  terminated: {
    title: 'Terima kasih telah membagikan masukan Anda!',
    text: 'Kami berharap dapat bertemu dengan Anda kembali di studi kami mendatang. Sampai saat itu, kami mengucapkan semoga hari Anda menyenangkan.\n\nSilakan tutup jendela browser ini.',
  },
  mismatch: {
    title: 'Terima kasih atas minat Anda',
    text: 'Sayangnya, Anda tidak termasuk dalam kelompok target untuk studi khusus ini.\n\nAnda dapat menutup halaman ini.',
  },
  error: {
    title: 'Kami tidak dapat memproses permintaan Anda',
    linkProblemDetailed:
      'Tautan yang Anda ikuti mengalami masalah. Mohon periksa apakah tautan pada baris alamat sesuai dengan yang diberikan kepada Anda, kemudian coba lagi.',
    linkProblemGeneric:
      'Tautan yang Anda ikuti mengalami masalah. Mohon coba lagi.',
    contactPerson:
      'Jika masalah ini masih berlanjut, mohon beri tahu orang yang memberikan tautan ini kepada Anda mengenai masalah ini.',
  },
};

export default id;
